export default function processStatusHandler(item) {
    let status_lable = ""
    switch (item) {
        case "upload":
          status_lable = "آپلود";
          break;
        case "processing":
          status_lable = "در حال پردازش";
          break;
        case "success":
          status_lable = "تکمیل شده";
          break;
        case "failure":
          status_lable = "ناموفق";
          break;
        default:
          break;
      };
      return status_lable;
}